import { render } from "./WarningMessage.vue?vue&type=template&id=db85a36c"
import script from "./WarningMessage.vue?vue&type=script&lang=js"
export * from "./WarningMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__